import { ReactNode } from 'react';
const Container = ({ children }: { children: ReactNode }) => {
  return (
    <div id="container">
      <div className="limitContainer">
        <div className="simpleContainer">{children}</div>
      </div>
    </div>
  );
};

export default Container;
